const version = "9.2.0";

export default version;

const [major, minor, patch] = version.split('.');
export { major, minor, patch };